import React, { useEffect, useState } from "react";
import { getCampaignById } from "../../../api/campaigns.api";
import AdminLayout from "../../layout/AdminLayout";
import { useParams } from "react-router-dom";
import { baseURL } from "../../../api/api";
import { FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner"; // Import the loader

function CampaignDetails() {
  const { id } = useParams();
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    setLoading(true); // Start loading
    getCampaignById(id)
      .then((res) => {
        console.log("Campaign Details", res.data);
        setCampaignDetails(res?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading after response
      });
  }, [id]);
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <AdminLayout title="Campaign Details">
      <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
        <Link
          to={`/campaigns/edit/${id}`}
          className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
        >
          {" "}
          <FiPlus className="text-lg text-gray-700" />
          Edit Campaign
        </Link>
      </div>

      {/* Show loader while fetching data */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <RotatingLines
            strokeColor="black"
            strokeWidth="5"
            animationDuration="0.75"
            width="96"
            visible={true}
          />
        </div>
      ) : (
        <div className="px-10 gap-5 grid grid-cols-12">
          <div className="lg:col-span-8 md:col-span-8 col-span-12">
            <div className="py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-12 ">
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Name
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {campaignDetails?.name}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 sm:col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Location
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {campaignDetails?.location}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 sm:col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Status
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {campaignDetails?.status}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 sm:col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Company
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {campaignDetails?.company?.name}
                </p>
              </div>
            </div>
            <div className="py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
              <div className="shadow-md p-3 mx-2 lg:col-span-4 md:col-span-12 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Start Date
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {formatDate(campaignDetails?.startDate)}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-4 md:col-span-12 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Number of Weeks
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {campaignDetails?.numberOfWeeks}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-4 md:col-span-12 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  End Date
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {formatDate(campaignDetails?.endDate)}
                </p>
              </div>
            </div>

            <div className="py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
              <div className="shadow-md p-3 mx-2 lg:col-span-6 md:col-span-6 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Number of Screens
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {campaignDetails?.numberOfScreens}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-6 md:col-span-12 sm:col-span-12">
                <div className="mt-3 px-4 flex items-center justify-between">
                  <div className="relative flex items-start">
                    <div className="ml-3 text-base leading-6">
                      <label className="font-medium text-gray-700">Paid</label>
                      <p className="mt-2 text-sm font-medium text-gray-600">
                        {campaignDetails?.paid ? "Yes" : "No"}
                      </p>
                    </div>
                  </div>
                  <div className="relative flex items-start">
                    <div className="ml-3 text-base leading-6">
                      <label className="font-medium text-gray-700">
                        Impressions
                      </label>
                      <p className="mt-2 text-sm font-medium text-gray-600">
                        {campaignDetails?.impressions}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
              <div className="shadow-md p-3 mx-2 lg:col-span-6 md:col-span-12 sm:col-span-12">
                <p className="flex items-center justify-between py-3 text-lg font-semibold leading-6 text-gray-600">
                  <span>Total Cost:</span>
                  <span className="text-lg text-gray-600">
                    € {campaignDetails?.totalCost}
                  </span>
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-6 md:col-span-12 sm:col-span-12">
                <p className="flex items-center justify-between py-3 text-lg font-semibold leading-6 text-gray-600">
                  <span>Campaign Type:</span>
                  <span className="text-lg text-gray-600">
                    {campaignDetails?.type}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 md:col-span-4 col-span-12">
            <div className="h-72 mt-2">
              <video
                src={`${baseURL}/s3/images/${campaignDetails?.video?.name}`}
                alt="Selected"
                className="h-full w-full object-cover"
                controls
                muted
              />
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

export default CampaignDetails;
